const EXPANDABLE_PROPERTIES = {
  border: ['borderColor', 'borderWidth', 'borderStyle'],
  borderTop: ['borderTopColor', 'borderTopWidth', 'borderTopStyle'],
  borderRight: ['borderRightColor', 'borderRightWidth', 'borderRightStyle'],
  borderBottom: ['borderBottomColor', 'borderBottomWidth', 'borderBottomStyle'],
  borderLeft: ['borderLeftColor', 'borderLeftWidth', 'borderLeftStyle'],
  borderInlineStart: ['borderInlineStartColor', 'borderInlineStartWidth', 'borderInlineStartStyle'],
  borderInlineEnd: ['borderInlineEndColor', 'borderInlineEndWidth', 'borderInlineEndStyle'],
  background: ['backgroundSize', 'backgroundColor', 'backgroundImage', 'backgroundClip', 'backgroundOrigin', 'backgroundPosition', 'backgroundRepeat', 'backgroundAttachment'],
  margin: ['marginTop', 'marginRight', 'marginBottom', 'marginLeft', 'marginInlineStart', 'marginInlineEnd'],
  padding: ['paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft', 'paddingInlineStart', 'paddingInlineEnd'],
  font: ['fontFamily', 'fontSize', 'fontStretch', 'fontStyle', 'fontVariant', 'fontWeight', 'lineHeight'],
  textDecoration: ['textDecorationColor', 'textDecorationLine', 'textDecorationStyle', 'textDecorationThickness']
};
export function expandCssProperties(cssProperties) {
  const expandedCssProperties = {
    ...cssProperties
  };
  for (const [shorthand, longhands] of Object.entries(EXPANDABLE_PROPERTIES)) {
    if (shorthand in expandedCssProperties) {
      for (const longhand of longhands) {
        if (!(longhand in expandedCssProperties)) {
          expandedCssProperties[longhand] = null;
        }
      }
    }
  }
  return expandedCssProperties;
}
//# sourceMappingURL=expandCSSProperties.js.map